export default "__VITE_ASSET__DGvWN45i__"